import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import classes from './Content.module.scss'

const Content = ({ children }) => (
  <Grid item xs={12} lg={8} className={clsx('Content', classes.root)}>
    <div className={classes.item}>{children}</div>
  </Grid>
)

export default Content
